/* global schools */
import React from 'react';
import PropTypes from 'prop-types';
import GoogleMap from '../Map.jsx';

const SchoolPage = () => (
    <div>
        <GoogleMap schools={schools} />
    </div>
);

SchoolPage.propTypes = {
    courses: PropTypes.array,
};

export default SchoolPage;
